import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import PropTypes from "prop-types";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";
import { Error, Success } from "../../assets/jss/util/messageUtil";

const Themphuongtien = React.memo(function Themphuongtien(props) {
  const { donviql_id } = props;
  const [loaihinhptvantai, setLoaihinhptvantai] = React.useState([]);
  const [selectedLoaihinh, setSelectedLoaihinh] = React.useState(null);
  const [sodangky, setSodangky] = React.useState("");
  const [taitrong, setTaitrong] = React.useState(0);
  const [succhua, setSucchua] = React.useState(0);
  const [messageValidate, setMessageValidate] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getloaihinhptvantai = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmloaihinhptvantaiall?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaihinhptvantai(data);
        setSelectedLoaihinh(data[0]);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const insertphuongtien = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Phuongtien/themphuongtien";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          dvvt_id: donviql_id,
          sodangky: sodangky,
          dmloaihinhptvantai_id: selectedLoaihinh.id,
          succhua: succhua,
          taitrong: taitrong,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setMessage(data);
          showNotification();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };
  const validateThem = () => {
    // Kiem tra cac truong bat buoc nhap
    if (sodangky.trim() === "") {
      return Error.ER0006;
    }
    if (!selectedLoaihinh || selectedLoaihinh.id === 0) {
      return Error.ER0007;
    }
    if (!donviql_id || donviql_id === 0) {
      return Error.ER0008;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getloaihinhptvantai();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số đăng ký"
                variant="outlined"
                size="small"
                value={sodangky}
                onChange={(event) => {
                  setSodangky(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Tải trọng"
                variant="outlined"
                size="small"
                value={taitrong}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setTaitrong(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Sức chứa"
                variant="outlined"
                value={succhua}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSucchua(value);
                }}
                size="small"
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                disableClearable
                size="small"
                options={loaihinhptvantai}
                value={selectedLoaihinh}
                getOptionLabel={(option) => option?.ten || ""}
                onChange={(event, value) => {
                  if (value) {
                    setSelectedLoaihinh(value);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại hình phương tiện vận tải"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "40px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={insertphuongtien}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={message}
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Themphuongtien.propTypes = {
  donviql_id: PropTypes.number,
};
export default Themphuongtien;
